import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, SendIcon } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const contactInfo = [{
    icon: MapPinIcon,
    title: 'Address',
    content: 'Kenyatta Avenue, Nakuru CBD\nNakuru, Kenya'
  }, {
    icon: PhoneIcon,
    title: 'Phone',
    content: '+254 700 123 456\n+254 711 234 567'
  }, {
    icon: MailIcon,
    title: 'Email',
    content: 'info@zingacreatives.com\nsupport@zingacreatives.com'
  }, {
    icon: ClockIcon,
    title: 'Business Hours',
    content: 'Mon - Fri: 8:00 AM - 6:00 PM\nSat: 9:00 AM - 4:00 PM'
  }];
  return <main className="min-h-screen bg-gray-50" data-id="element-288">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-16 px-4" data-id="element-289">
        <div className="max-w-4xl mx-auto text-center" data-id="element-290">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-291">Contact Us</h1>
          <p className="text-xl text-blue-100" data-id="element-292">
            We'd love to hear from you. Get in touch with our team.
          </p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-293">
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-294">
          {/* Contact Form */}
          <div className="bg-white rounded-xl shadow-md p-8" data-id="element-295">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-296">
              Send us a Message
            </h2>

            {submitted ? <div className="text-center py-12" data-id="element-297">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 text-green-600 rounded-full mb-4" data-id="element-298">
                  <SendIcon className="w-8 h-8" data-id="element-299" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-300">
                  Message Sent!
                </h3>
                <p className="text-gray-600" data-id="element-301">
                  Thank you for contacting us. We'll get back to you soon.
                </p>
                <button onClick={() => {
              setSubmitted(false);
              setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
              });
            }} className="mt-4 text-blue-600 hover:text-blue-700 font-medium" data-id="element-302">
                  Send another message
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-303">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-304">
                  <div data-id="element-305">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-306">
                      Your Name *
                    </label>
                    <input type="text" id="name" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="John Doe" required data-id="element-307" />
                  </div>
                  <div data-id="element-308">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-309">
                      Email Address *
                    </label>
                    <input type="email" id="email" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="john@example.com" required data-id="element-310" />
                  </div>
                </div>
                <div data-id="element-311">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-312">
                    Subject *
                  </label>
                  <input type="text" id="subject" value={formData.subject} onChange={e => setFormData({
                ...formData,
                subject: e.target.value
              })} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="How can we help?" required data-id="element-313" />
                </div>
                <div data-id="element-314">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-315">
                    Message *
                  </label>
                  <textarea id="message" value={formData.message} onChange={e => setFormData({
                ...formData,
                message: e.target.value
              })} rows={5} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Your message..." required data-id="element-316" />
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2" data-id="element-317">
                  <SendIcon className="w-5 h-5" data-id="element-318" />
                  <span data-id="element-319">Send Message</span>
                </button>
              </form>}
          </div>

          {/* Contact Information */}
          <div data-id="element-320">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-321">
              Contact Information
            </h2>
            <div className="space-y-6" data-id="element-322">
              {contactInfo.map((info, index) => <div key={index} className="flex items-start space-x-4" data-id="element-323">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center" data-id="element-324">
                    <info.icon className="w-6 h-6" data-id="element-325" />
                  </div>
                  <div data-id="element-326">
                    <h3 className="font-semibold text-gray-900" data-id="element-327">
                      {info.title}
                    </h3>
                    <p className="text-gray-600 whitespace-pre-line" data-id="element-328">
                      {info.content}
                    </p>
                  </div>
                </div>)}
            </div>

            {/* Map Placeholder */}
            <div className="mt-8 bg-gray-200 rounded-xl h-64 flex items-center justify-center" data-id="element-329">
              <div className="text-center text-gray-500" data-id="element-330">
                <MapPinIcon className="w-12 h-12 mx-auto mb-2" data-id="element-331" />
                <p data-id="element-332">Map View</p>
                <p className="text-sm" data-id="element-333">Nakuru, Kenya</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}